const LOWERCASE_PARTICLES = new Set(['de', 'del', 'la', 'las', 'los', 'el', 'i', 'y', 'da', 'do', 'das', 'dos', 'van', 'von', 'der', 'di', "d'", 'l', 'lo']);

export function toProperCase(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed !== trimmed.toUpperCase() && trimmed !== trimmed.toLowerCase()) {
    return null;
  }
  const lower = trimmed.toLowerCase();
  const out = lower.replace(/(^|[\s'\-])(\p{L})/gu, (m, sep, ch, offset) => {
    const wordStart = offset + sep.length;
    const wordMatch = lower.slice(wordStart).match(/^[\p{L}']+/u);
    const word = wordMatch ? wordMatch[0] : ch;
    if (offset > 0 && LOWERCASE_PARTICLES.has(word)) {
      return sep + ch;
    }
    return sep + ch.toUpperCase();
  });
  return out === value ? null : out;
}
